import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';

import type { Color } from '@opendoor/tokens-studio/dist/bricks-next/types/Novo';
import { getToken } from '@tamagui/core';

type BricksSvgProps = Omit<SvgProps, 'width' | 'height' | 'color'> & {
  size?: 20 | 24,
  color?: Color,
};
const SvgSign = ({ size = 24, color = '$contentPrimary', ...inProps }: BricksSvgProps) => {
  const outProps: SvgProps = {};
  if (size) {
    outProps.width = size;
    outProps.height = size;
  }
  if (color) {
    const colorToken = getToken(color, 'color');
    outProps.color = colorToken;
  }
  const props = {
    viewBox: '0 0 24 24',
    ...inProps,
    ...outProps,
  };
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
      <Path
        fill="currentColor"
        d="M5.25 3a1.25 1.25 0 1 0-2.5 0v.75H2a1.25 1.25 0 1 0 0 2.5h.75v15.8h2.5V6.25H21a1.25 1.25 0 1 0 0-2.5H5.25z"
      />
      <Path
        fill="currentColor"
        fillRule="evenodd"
        d="M19 10.5h-9a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5M10 8a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3z"
        clipRule="evenodd"
      />
    </Svg>
  );
};
export default SvgSign;
